import React from 'react';
import { AppIcon, AppIconName } from '../../icons/appIcons.tsx';

interface PageTitleProps {
  icon?: AppIconName;
  children: React.ReactNode;
  className?: string;
}

export default function PageTitle({ icon, children, className = '' }: PageTitleProps) {
  return (
    <h1 className={`flex items-center gap-2.5 text-2xl sm:text-3xl font-bold text-gray-900 ${className}`}>
      {icon && (
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-ggaa-green/10 text-ggaa-green shrink-0">
          <AppIcon name={icon} className="w-5 h-5" />
        </span>
      )}
      <span>{children}</span>
    </h1>
  );
}
